
import { AuthService, DossierService, TicketService } from "@/services";
import { InitInfo } from "@/utils/init-info";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";

export default FormLike.extend({
	data() {
		return {
			companyName: "",
			vatNumber: "",
			sendAndReceive: 1,
		};
	},
	props: {
		content: Object as () => InitInfo,
		controlsDisabled: Boolean
	},
	computed: {
		isFormValid(): boolean {
			return this.companyName !== "" && this.vatNumber !== "";
		}
	},
	methods: {
		prev() {
			this.$emit("prev");
		},
		skip() {
			this.$emit("skip");
		},
		async activate() {
			this.$emit("disable");
			try {
				let s = "Nieuwe aanvraag tot PEPPOL registratie";
				let c = "Nieuwe aanvraag tot PEPPOL registratie\nFirmanaam: " + this.companyName;
				c = c + "\nBTW nummer: " + this.vatNumber;
				c = c + (this.sendAndReceive == 1 ? "\nIk wil graag VERZENDEN EN ONTVANGEN" : "\nIk wil graag ENKEL VERZENDEN");
				await TicketService.newTicket(s, c, [], "1", "1");

				let id = AuthService.wfDossier.id;
				await DossierService.activatePeppol(id);
				AuthService.wfDossier.peppolRegistrationStatus = 1;
			} catch (err) {
				// silently continue
			}
			this.$emit("next");
		}
	},
	mounted() {
		this.companyName = this.content.companyName || "";
		this.vatNumber = this.content.vatNo || "";
	},
	i18nEx: {
		componentPrefix: "components.init-modal"
	}
});
